import { GameSummaryMetadata } from '@/redux/types/room'

export const getPlayerName = (player: GameSummaryMetadata['players'][0]) => {
  if (player.gamealias) return player.gamealias
  const firstName = player.member__first_name || ''
  const lastName = player.member__last_name || ''
  if (firstName || lastName) return `${firstName} ${lastName}`.trim()
  return player.member__email
}
